<template>
  <div class="search" ref="searchRef">
    <div class="search-tag">
      <div class="search-tag-tag">
        <i class="el-icon-third-delete_all" @click="clearAllTags"/>
        <search-tag v-for="(tag,i) in tags" :key="'tag-'+i"
                    :tag="{index:i,...tag}"
                    @close="closeTag(tag, i)"/>
      </div>
      <div class="search-tag-button" v-if="showButton">
        <slot name="button"/>
        <el-button @click="toExport"
                   class="new-button"
                   icon="el-icon-download"
                   type="success"
                   v-if="exportType">
          {{exportStr}}
        </el-button>
        <el-button type="primary" @click="toNew" class="new-button" v-url-check="checkUrl"  v-if="newStrType">
          <i class="el-icon-third-hao"/>
          {{ newStr }}
        </el-button>
      </div>
    </div>
    <div class="search-input">
      <div class="main">
        <div class="show" v-for="item in realSearchObjList" :key="item.name">
          <search-item :clear="clear"
                       :search-input="item" :key="item.name"
                       :defaultValue="item.defaultValue"
                       :is-more="isMore"
                       @pushTab="pushTab"
                       @pushTabTwo="pushTabTwo"
                       @closeTab="closeTab"
                       :ref="item.param">
            <template v-slot:searchItem v-if="item.searchType==='slot'">
              <slot name="search" v-bind:item="item" v-bind:pushTab="pushTab" v-bind:pushTabTwo="pushTabTwo"/>
            </template>
          </search-item>
        </div>
      </div>
      <div @click="more" class="choose" v-if="searchObjType">
        <i :class="`el-icon-caret-${isMore?'top':'bottom'}`"/>
        <span>更多筛选</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 查询栏组件
 * @author: 菩萨蛮
 * @date 2020/2/12 7:48 下午
 * @version V1.0.2
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 *
 * TODO tab过多的时候滚动样式
 * v1.0.1 添加slot
 * v1.0.2 添加showButton来决定是否展示按钮模块
 */

import SearchItem from './SearchItem';
import SearchTag from './SearchTag';

export default {
  name: 'Search',
  components: { SearchItem, SearchTag },
  props: {
    searchObjList: { type: Array },
    newStr: { type: String, default: '新增' },
    router: { type: String },
    showButton: { type: Boolean, default: true },
    searchObjType: { type: Boolean, default: false },
    exportStr: { type: String, default: '导出' },
    exportType: { type: Boolean, default: false },
    checkUrl: { type: String, default: '' },
    newStrType: { type: Boolean, default: true },
  },
  data() {
    return {
      tags: [],
      isMore: false,
      clear: 0
    };
  },
  computed: {
    realSearchObjList() {
      const baseList = this.searchObjList.filter(e => e.isShow !== false);
      const moreList = this.searchObjList.filter(e => e.isShow === false);

      if (this.isMore) {
        return [...baseList, ...moreList];
      }
      return baseList;
    }
  },
  methods: {
    more() {
      this.isMore = !this.isMore;
      setTimeout(() => {
        this.$emit('getHeight', this.$refs.searchRef.offsetHeight);
      }, 50);
    },
    pushTab(searchObj) {
      // 这里之后要改成如果是选择框
      // if (searchObj.type === 'input' || searchObj.type === 'select') {
      //
      // }
      // 如果搜索框中存在这个字段，则替换
      if (this.tags.map(e => e.param).includes(searchObj.param)) {
        const index = this.tags.findIndex(e => e.param === searchObj.param);
        this.tags.splice(index, 1, searchObj);
      } else {
        this.tags.push(searchObj);
      }
      this.tags = this.tags.filter(e => e.name.split(':')[1] !== '');
      // 修改完毕tabs后刷新列表
      this.$emit('reSearch', this.tags);
    },
    pushTabTwo(searchObj) {
      // 如果搜索框中存在这个字段，则替换
      if (this.tags.map(e => e.param).includes(searchObj.param) || this.tags.map(e => e.name.split(':')[0]).includes(searchObj.name.split(':')[0])) {
        const index = this.tags.findIndex(e => e.param === searchObj.param || e.name.split(':')[0] === searchObj.name.split(':')[0]);
        this.tags.splice(index, 1, searchObj);
      } else {
        this.tags.push(searchObj);
      }
      this.tags = this.tags.filter(e => e.name.split(':')[1] !== '');
      // 修改完毕tabs后刷新列表
      this.$emit('reSearch', this.tags);
    },
    closeTab(searchObj) {
      if (this.tags.map(e => e.param).includes(searchObj.param)) {
        const index = this.tags.findIndex(e => e.param === searchObj.param);
        this.tags.splice(index, 1);
      }
      this.$emit('reSearch', this.tags);
    },
    closeTag(tag, i) {
      if (tag.type === 'date') {
        this.$refs[`${tag.param}`][0].input = [];
      }
      if (tag.type === 'radio') {
        let arr = this.realSearchObjList.filter(item => item.type === 'radio');
        let j = arr.findIndex(item => item.selectList.findIndex(e => e.param === tag.param) !== -1);
        if (j !== -1) {
          this.$refs[`${arr[j].param}`][0].input = '';
        }
      }
      if (tag.type === 'autocomplete') {
        if (this.$refs[`${tag.param}`]) {
          this.$refs[`${tag.param}`][0].$children[0].supplierValue = '';
        } else {
          let keys = Object.keys(this.$refs);
          const k = keys.findIndex(item => this.$refs[item][0].searchInput.name === tag.name.split(':')[0]);
          this.$refs[keys[k]][0].$children[0].supplierValue = '';
        }
      }
      if (tag.type === 'checkbox') {
        this.$refs[`${tag.param}`][0].input = '';
      }
      if (tag.type === 'input') {
        this.$refs[`${tag.param}`][0].input = '';
      }
      this.tags.splice(i, 1);
      this.$emit('reSearch', this.tags);
    },
    clearAllTags() {
      this.tags = [];
      this.clear++;
      this.$emit('reSearch', this.tags);
    },
    toNew() {
      this.$emit('toNew');
    },
    toExport() {
      this.$emit('exportSearch', this.tags);
    }
  }
};
</script>

<style lang="scss" scoped>
.search {
  width: 100%;
  border-radius: 4px;
  background-color: #fff;

  .search-tag,
  .search-input {
    position: relative;
    width: calc(100% - 225px);
    margin-left:24px;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .search-tag {
    height: 45px;
    border-bottom: 1px solid #e6eaee;
    line-height: 45px;
    white-space: nowrap;
    // position:absolute;
    background: white;
    z-index: 1;
    width: calc(100% - 40px);

    .search-tag-tag {
      display: inline-block;
      width: calc(100% - 280px);
      overflow-x: auto;
      overflow-y: hidden;
      vertical-align: top;

      i {
        cursor: pointer;

        .el-icon-third-delete_all {
          cursor: pointer;
        }
      }
    }

    .search-tag-button {
      display: inline-block;
      width: 280px;
      text-align: right;
      margin-right: 10px;
      vertical-align: top;
      // float: right;

      /* title 文字提示 */
      .search-tag-title {
        float: left;
        margin-left: 205px;

        .el-icon-third-zhengyan {
          cursor: pointer;
        }
      }

      .new-button {
          max-width: 160px;
          height: 32px;
          padding: 0 10px;
          line-height: 32px;
          margin-right: 5px;
      }
    }
  }

  .search-input {
    line-height: 48px;
    // padding-top: 50px;
    width: calc(100% - 70px);
    .main {
      width: calc(100% - 70px);

      .show {
        display: inline-block;
      }
    }

    .choose {
      position: absolute;
      top: 0;
      right: 0;
      width: 62px;
      margin-left: 30px;

      span,
      i {
        font-weight: 500;
        font-size: 10px;
        color: rgba(132, 151, 179, 1);
        cursor: pointer;
      }
    }
  }
}

</style>
